import { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
   exportExcelChartUserTypeAsync,
   getChartUserTypeAsync,
} from "../../states/chartUserType/chartUserType.action"
import {
   selectDataChartUserType,
   selectErrorChartUserType,
   selectIsDisableExport,
   selectIsDisableStatistic,
   selectRequestingChartUserType,
   selectRequestingExportChartUserType,
   selectSearchConditionChartUserType,
} from "../../states/chartUserType/chartUserType.selector"
import { changeSearchCondtion } from "../../states/chartUserType/chartUserType.slice"
import { ChartUserTypeComponent } from "./chartUserType.component"

export const ChartUserTypeContainer = () => {
   const dispatch = useDispatch()
   const refChart = useRef([])
   // Selector chart
   const requestingChart = useSelector(selectRequestingChartUserType)
   const requestingExport = useSelector(selectRequestingExportChartUserType)
   const dataChart = useSelector(selectDataChartUserType)
   const errorChart = useSelector(selectErrorChartUserType)
   const searchConditionChart = useSelector(selectSearchConditionChartUserType)
   const isDisableStatistic = useSelector(selectIsDisableStatistic)
   const isDisableExport = useSelector(selectIsDisableExport)

   /**
    * Handle statistic
    */
   const handleStatistic = () => {
      dispatch(getChartUserTypeAsync())
   }

   /**
    * Handle change search condition
    * @param data
    */
   const handleChangeSearchCondition = (data: any) => {
      dispatch(changeSearchCondtion(data))
   }

   /**
    * Handle chart export
    */
   const handleChartExport = async () => {
      dispatch(exportExcelChartUserTypeAsync({ refChart: refChart }))
   }

   return (
      <ChartUserTypeComponent
         refChart={refChart}
         requestingChart={requestingChart}
         requestingExport={requestingExport}
         dataChart={dataChart}
         errorChart={errorChart}
         searchConditionChart={searchConditionChart}
         isDisableStatistic={isDisableStatistic}
         isDisableExport={isDisableExport}
         handleStatistic={handleStatistic}
         handleChangeSearchCondition={handleChangeSearchCondition}
         handleChartExport={handleChartExport}
      />
   )
}
